import script from "./Warehouses.vue?vue&type=script&setup=true&lang=js"
export * from "./Warehouses.vue?vue&type=script&setup=true&lang=js"

import "./Warehouses.vue?vue&type=style&index=0&id=4a635d90&lang=css"

const __exports__ = script;

export default __exports__